import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
import { isNgTemplate } from '@angular/compiler';
declare var jQuery: any;
import * as moment from 'moment';


@Component({
	selector: 'app-time',
	templateUrl: './business-video.component.html',
	styleUrls: ['./business-video.component.css']
})
export class BusinessVideoComponent implements OnInit {
	timeForm: FormGroup;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	searchStr: any = '';
	modalTitle: any;
	timeList: any
	btnTitle: any;
	type: any;
	selectedTimeId: any;
	isTimeAvailable: boolean = true;
	isActivatedAdd: boolean = false;
	isActivatedEdit: boolean = false;
	isActivatedDelete: boolean = false;
	src: any;
	moment: any = moment;
	countryList: any;
    categoryList: any;



	@ViewChild('videoPlayer') videoplayer: ElementRef;
	//src:String = "";

	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private validationService: ValidationService,
		private pagerService: PagerService) { }

	ngOnInit() {
		$(".navbar-brand").text("Business Video");
		this.timeForm = new FormGroup({
			time: new FormControl("", Validators.compose([
				Validators.required,
			])),
			businessCharge: new FormControl("", Validators.compose([
				Validators.required,
			])),
		});

		this.pageNo = 1;
		this.limit = 10;
		this.getBusinessVideoList(this.pageNo, this.limit, this.searchStr)
		this.getFilterList();
	}

	// Get Country and category list
	getFilterList = function () {

		this.authService.getCountryList().subscribe(data => {
			if (data.success) {

				this.countryList = data.country;
			}
			else {
				this.isCountryAvailable = false;
				this.countryList = [];
			}
			this.commonService.hideProcess();
		});
		this.authService.getSurveyCategoryList().subscribe(data => {
					if (data.success) {
						var that = this;
						this.surveyCategoryList = data.category;
						// setTimeout(function () {
						// 	$("#surveyCategory").val(that.surveyCategory);
						// 	$("#surveyStatus").val(that.surveyStatus);
						// 	$("#search").val(that.searchStr);
						// 	$('#page_' + that.activePageNo).addClass('active');
						// 	if (that.activePageNo == 1)
						// 		$('#first, #prev').addClass('disabled');
						// 	else if (that.activePageNo == that.pager.totalPages)
						// 		$('#next, #last').addClass('disabled');
						// }, 300);
					}
		});

	}

	//Get Time list
	getBusinessVideoList = function (pageNo, limit, searchStr) {

		this.commonService.process();

		this.authService.getBusinessVideoList(pageNo, limit, searchStr).subscribe(data => {
			console.log("getBusinessVideoList",data)
			if (data.success) {
				console.log("data",data)
				this.timeList = data.businessVideo;
				this.isTimeAvailable = true;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			}
			else {
				this.isTimeAvailable = false;
				this.timeList = [];
			}
			this.commonService.hideProcess();
		})
	}
	getBusinessVideoSearchList = function (pageNo, limit, startdate, expirydate, videoCategory, videoCountry) {

		this.commonService.process();

		this.authService.getBusinessVideoSearchList(pageNo, limit, startdate, expirydate, videoCategory, videoCountry).subscribe(data => {
			console.log("getBusinessVideoSearchList",data)
			if (data.success) {
				console.log("data",data)
				this.timeList = data.businessVideo;
				this.isTimeAvailable = true;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			}
			else {
				this.isTimeAvailable = false;
				this.timeList = [];
			}
			this.commonService.hideProcess();
		})
	}
	// Pagination
	setPage(page: number, param) {

		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		//this.pageNo = page;
		this.pager = this.pagerService.getPager(this.total, page);

		// get current page of items
		this.pagedItems = this.timeList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getBusinessVideoList(page, this.limit, this.searchStr);
		}
	}

	// Add Time
	addTime = function () {
		this.isActivatedAdd = true;
		this.isActivatedEdit = false;
		this.isActivatedDelete = false;
		this.modalTitle = "Add Time";
		this.btnTitle = "Save";
		this.timeForm.reset();
	}

	// Update selected time
	updateSelectedTime = function (time, type) {
		this.isActivatedAdd = false;
		this.isActivatedEdit = true;
		this.isActivatedDelete = false;
		this.modalTitle = "Update Time";
		this.btnTitle = "Update";
		this.type=type
		this.selectedTimeId = time._id;
		this.timeForm.controls['time'].setValue(time.time);
		this.timeForm.controls['businessCharge'].setValue(time.businessCharge);
		this.authService.changeBusinessVideoStatus({status:type,_id:time._id}).subscribe(data => {
			if (data.success) {
				jQuery.growl.notice({ title: 'Success', message: data.message });
				this.getBusinessVideoList(1, this.limit, this.searchStr);
			}
			else {
				jQuery.growl.error({ title: 'Error', message: data.error });
			}
			jQuery(':button[type="submit"]').attr('disabled', false);
			this.authService.cancelProcess();
		});
	}

	// Delete Selected time
	deleteSelectedTime = function (time) {
		this.isActivatedAdd = false;
		this.isActivatedEdit = false;
		this.isActivatedDelete = true;
		this.modalTitle = "Delete Time";
		this.btnTitle = "Yes";
		this.selectedTimeId = time._id;
		this.time = time;
	}

	// manage new time
	manageTime = function (timeForm,) {

		if (this.timeForm.valid && this.isActivatedAdd) {
			this.btnTitle = "Saving...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageTime(timeForm, "add").subscribe(data => {
				if (data.success) {
					jQuery.growl.notice({ title: 'Success', message: data.message });
					this.getBusinessVideoList(1, this.limit, this.searchStr);
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else if (this.timeForm.valid && this.isActivatedEdit) {
			timeForm._id = this.selectedTimeId;
			this.btnTitle = "Updating...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageTime(timeForm, "edit", this.selectedTimeId).subscribe(data => {
				if (data.success) {
					this.getBusinessVideoList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else if (this.isActivatedDelete) {
			timeForm._id = this.selectedTimeId;
			this.btnTitle = "Deleting...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageTime(timeForm, "delete", this.selectedTimeId).subscribe(data => {
				if (data.success) {

					this.getBusinessVideoList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else {
			this.validationService.validateAllFormFields(this.timeForm);
		}
	}

	// Search Time
	searchTime = function () {
		this.searchStr = jQuery("#search").val();
		this.getBusinessVideoList(1, this.limit, this.searchStr);
	}

	toggleVideo(event: any) {
		console.log("aaaaaaaa")
		this.videoplayer.nativeElement.play();
	}

	playVideo(data){
		console.log("data",data.businessVideoLink)
		//var imagefinal = data.businessVideoLink.replace(".mov", ".mp4")
		//this.src = data.businessVideoLink ? imagefinal : '';
		this.src = data.businessVideoLink ? data.businessVideoLink : '';
		//this.src="<source src='https://res.cloudinary.com/dsifmjwjo/video/upload/v1660681418/BusinessVideo/uru55le7fjprcg0tqhns.mp4' type='video/mp4' />"
	}

	searchBusinessVideoActivity = function () {
		var startdate = $('#startdate').val();
		var expirydate = $('#expirydate').val();
		var videoCategory = $('#videoCategory').val();
		var videoCountry = $('#videoCountry').val();
		var param = `startdate=` + startdate + `&expirydate=` + expirydate + `&category=` + videoCategory + `&country=` + videoCountry;
		debugger
		console.log("param",param)
		this.getBusinessVideoSearchList(1, this.limit, startdate, expirydate, videoCategory, videoCountry);

		//this.getSurveyList(1, this.limit, param)
	}

}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/business-video/business-video.component.ts